// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.row {
    display: flex;
    flex-direction: row;
    align-items: center;
}

ion-button {
    margin-left: 0.5rem;
}

ion-popover {
    --width: 250px;
}

label {
    padding-left: 0.5rem;
}

div:not(:last-child) {
    margin-bottom: 0.5rem;
}`, "",{"version":3,"sources":["webpack://./src/app/registration/formly/radio-input/radio-input.type.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,qBAAqB;AACzB","sourcesContent":[".row {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n}\n\nion-button {\n    margin-left: 0.5rem;\n}\n\nion-popover {\n    --width: 250px;\n}\n\nlabel {\n    padding-left: 0.5rem;\n}\n\ndiv:not(:last-child) {\n    margin-bottom: 0.5rem;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
